const API_URL = 'https://vdvwbwrl87.execute-api.us-east-1.amazonaws.com/containers/photos/';
const AWS = require('aws-sdk')

export const fetchImageInfo = async (containerId) => {
  try {
    const response = await fetch(`${API_URL}${containerId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    let result = await response.json();
    return result.data
  } catch (error) {
    throw new Error(error.message);
  }
};

export const removeImages = async (containerId) => {
  try {
    //get list of images by container
    const images = await fetchImageInfo(containerId)
    const myBucket = 'us-east-1-992382708231-transferfamily-data'
    const s3 = new AWS.S3({
      region: 'us-east-1',
    });

    images.forEach(element => {
      s3.deleteObject({
        Bucket: myBucket,
        Key: element.Key
      }, function (err, data) { if (err) {console.log(err)}})
    });
    return {}
  } catch (error) {
    throw new Error(error.message);
  }
}
